import { chartNames, eventStatuses, settingNames } from "../../consts";
import { arrayUtil, rumEventsUtil } from "../../utils";

// Setting Usage
// _________________________________________________________________________
const getSettingUsage = (data, devices) => {
  const metricsConfig = rumEventsUtil.getMetricsConfig({ chartName: chartNames.SETTING_USAGE });

  const chartData = rumEventsUtil.prepareChartData({
    data,
    devices,
    groupFn: (event) => rumEventsUtil.formatSettingName(event?.eventDetails?.settingName)
  });

  if (!chartData?.grouped || !chartData?.dates || !metricsConfig) {
    return [];
  }

  const { grouped } = chartData;
  const settings = Object.keys(settingNames).map((key) => settingNames[key]);

  const result = [];

  grouped?.size > 0 &&
    settings.forEach((setting) => {
      const events = grouped.get(setting);

      let successful = 0;
      let failed = 0;

      if (events && events?.length > 0) {
        events.map((event) => {
          if (event?.eventDetails?.status === eventStatuses.SUCCESS) {
            successful += 1;
          } else {
            failed += 1;
          }
        });
      }

      result.push({
        setting: setting,
        metrics: {
          [metricsConfig.successful.id]: successful,
          [metricsConfig.failed.id]: failed
        }
      });
    });

  return result;
};

// Setting Perfomance
// _________________________________________________________________________
const getSettingPerfomance = (data, setting) => {
  const metricsConfig = rumEventsUtil.getMetricsConfig({ chartName: chartNames.SETTING_PERFOMANCE });
  const chartData = rumEventsUtil.prepareChartData({
    data,
    setting: setting
  });

  if (!chartData?.grouped || !chartData?.dates || !metricsConfig) {
    return [];
  }

  const { grouped, dates } = chartData;
  const result = [];

  grouped?.size > 0 &&
    dates.forEach((day) => {
      const events = grouped.get(day);
      const settingName = settingNames[setting];

      let settingsCount = 0;
      let avgSpeed = 0;

      if (events && events?.length > 0) {

        const durationList = [];

        events.forEach((event) => {
          if (event?.eventDetails?.duration !== null && event?.eventDetails?.status !== eventStatuses.FAILED) {
            durationList.push(event.eventDetails.duration);
            settingsCount++;
          }
        });

        avgSpeed = durationList.length
          ? arrayUtil.getAverageValue(durationList)
          : 0;
      }

      result.push({
        date: day,
        metrics: {
          [metricsConfig[settingName].id]: settingsCount,
          [metricsConfig.speed.id]: avgSpeed
        }
      });
    });
  return result;
};

const settingsDashboardUtil = {
  // Setting Usage
  // _________________________________________________________________________
  getSettingUsage,
  // Setting Perfomance
  // _________________________________________________________________________
  getSettingPerfomance
};

export default settingsDashboardUtil;
